/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDirectEmrIntegrationsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.GetEmrIntegrationsInput>;
}>;


export type GetDirectEmrIntegrationsQuery = { __typename?: 'Query', listDirectEmrApiIntegrations: Array<{ __typename?: 'DirectEmrApiEndpoint', emr_type: Types.EmrApiType, fhir_api_endpoint_id: string, fhir_base_url: string, organization_name: string, organization_logo_url?: string | null, city?: string | null, country?: string | null, region?: string | null }> };

export type GetEmrConnectionsQueryVariables = Types.Exact<{
  input: Types.GetEmrConnectionsInput;
}>;


export type GetEmrConnectionsQuery = { __typename?: 'Query', listDirectEmrApiConnections: Array<{ __typename?: 'DirectEmrApiConnection', vitall_patient_id: string, fhir_api_endpoint_id: string, patient: string, expiry: string, created_at: string, updated_at: string }> };

export type GetAuthorizationUrlQueryVariables = Types.Exact<{
  input: Types.EmrConnectionInput;
}>;


export type GetAuthorizationUrlQuery = { __typename?: 'Query', getDirectEmrApiAuthorizationURL: string };

export type CreateEmrConnectionMutationVariables = Types.Exact<{
  input: Types.PostEmrConnectionInput;
}>;


export type CreateEmrConnectionMutation = { __typename?: 'Mutation', postDirectEmrApiConnection: { __typename?: 'DirectEmrApiConnection', vitall_patient_id: string, fhir_api_endpoint_id: string, patient: string, expiry: string, created_at: string, updated_at: string } };

export type DeleteEmrConnectionMutationVariables = Types.Exact<{
  input: Types.EmrConnectionInput;
}>;


export type DeleteEmrConnectionMutation = { __typename?: 'Mutation', deleteDirectEmrApiConnection: { __typename?: 'DirectEmrApiConnection', vitall_patient_id: string, fhir_api_endpoint_id: string, patient: string, expiry: string, created_at: string, updated_at: string } };


export const GetDirectEmrIntegrationsDocument = gql`
    query getDirectEMRIntegrations($input: GetEmrIntegrationsInput) {
  listDirectEmrApiIntegrations(input: $input) {
    emr_type
    fhir_api_endpoint_id
    fhir_base_url
    organization_name
    organization_logo_url
    city
    country
    region
  }
}
    `;
export function useGetDirectEmrIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetDirectEmrIntegrationsQuery, GetDirectEmrIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectEmrIntegrationsQuery, GetDirectEmrIntegrationsQueryVariables>(GetDirectEmrIntegrationsDocument, options);
      }
export function useGetDirectEmrIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectEmrIntegrationsQuery, GetDirectEmrIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectEmrIntegrationsQuery, GetDirectEmrIntegrationsQueryVariables>(GetDirectEmrIntegrationsDocument, options);
        }
// @ts-ignore
export function useGetDirectEmrIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectEmrIntegrationsQuery, GetDirectEmrIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDirectEmrIntegrationsQuery, GetDirectEmrIntegrationsQueryVariables>;
export function useGetDirectEmrIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectEmrIntegrationsQuery, GetDirectEmrIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDirectEmrIntegrationsQuery | undefined, GetDirectEmrIntegrationsQueryVariables>;
export function useGetDirectEmrIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectEmrIntegrationsQuery, GetDirectEmrIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectEmrIntegrationsQuery, GetDirectEmrIntegrationsQueryVariables>(GetDirectEmrIntegrationsDocument, options);
        }
export type GetDirectEmrIntegrationsQueryHookResult = ReturnType<typeof useGetDirectEmrIntegrationsQuery>;
export type GetDirectEmrIntegrationsLazyQueryHookResult = ReturnType<typeof useGetDirectEmrIntegrationsLazyQuery>;
export type GetDirectEmrIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetDirectEmrIntegrationsSuspenseQuery>;
export type GetDirectEmrIntegrationsQueryResult = Apollo.QueryResult<GetDirectEmrIntegrationsQuery, GetDirectEmrIntegrationsQueryVariables>;
export const GetEmrConnectionsDocument = gql`
    query getEMRConnections($input: GetEmrConnectionsInput!) {
  listDirectEmrApiConnections(input: $input) {
    vitall_patient_id
    fhir_api_endpoint_id
    patient
    expiry
    created_at
    updated_at
  }
}
    `;
export function useGetEmrConnectionsQuery(baseOptions: Apollo.QueryHookOptions<GetEmrConnectionsQuery, GetEmrConnectionsQueryVariables> & ({ variables: GetEmrConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmrConnectionsQuery, GetEmrConnectionsQueryVariables>(GetEmrConnectionsDocument, options);
      }
export function useGetEmrConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmrConnectionsQuery, GetEmrConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmrConnectionsQuery, GetEmrConnectionsQueryVariables>(GetEmrConnectionsDocument, options);
        }
// @ts-ignore
export function useGetEmrConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmrConnectionsQuery, GetEmrConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmrConnectionsQuery, GetEmrConnectionsQueryVariables>;
export function useGetEmrConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmrConnectionsQuery, GetEmrConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmrConnectionsQuery | undefined, GetEmrConnectionsQueryVariables>;
export function useGetEmrConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmrConnectionsQuery, GetEmrConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmrConnectionsQuery, GetEmrConnectionsQueryVariables>(GetEmrConnectionsDocument, options);
        }
export type GetEmrConnectionsQueryHookResult = ReturnType<typeof useGetEmrConnectionsQuery>;
export type GetEmrConnectionsLazyQueryHookResult = ReturnType<typeof useGetEmrConnectionsLazyQuery>;
export type GetEmrConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetEmrConnectionsSuspenseQuery>;
export type GetEmrConnectionsQueryResult = Apollo.QueryResult<GetEmrConnectionsQuery, GetEmrConnectionsQueryVariables>;
export const GetAuthorizationUrlDocument = gql`
    query getAuthorizationURL($input: EmrConnectionInput!) {
  getDirectEmrApiAuthorizationURL(input: $input)
}
    `;
export function useGetAuthorizationUrlQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorizationUrlQuery, GetAuthorizationUrlQueryVariables> & ({ variables: GetAuthorizationUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorizationUrlQuery, GetAuthorizationUrlQueryVariables>(GetAuthorizationUrlDocument, options);
      }
export function useGetAuthorizationUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorizationUrlQuery, GetAuthorizationUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorizationUrlQuery, GetAuthorizationUrlQueryVariables>(GetAuthorizationUrlDocument, options);
        }
// @ts-ignore
export function useGetAuthorizationUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuthorizationUrlQuery, GetAuthorizationUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuthorizationUrlQuery, GetAuthorizationUrlQueryVariables>;
export function useGetAuthorizationUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthorizationUrlQuery, GetAuthorizationUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuthorizationUrlQuery | undefined, GetAuthorizationUrlQueryVariables>;
export function useGetAuthorizationUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthorizationUrlQuery, GetAuthorizationUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthorizationUrlQuery, GetAuthorizationUrlQueryVariables>(GetAuthorizationUrlDocument, options);
        }
export type GetAuthorizationUrlQueryHookResult = ReturnType<typeof useGetAuthorizationUrlQuery>;
export type GetAuthorizationUrlLazyQueryHookResult = ReturnType<typeof useGetAuthorizationUrlLazyQuery>;
export type GetAuthorizationUrlSuspenseQueryHookResult = ReturnType<typeof useGetAuthorizationUrlSuspenseQuery>;
export type GetAuthorizationUrlQueryResult = Apollo.QueryResult<GetAuthorizationUrlQuery, GetAuthorizationUrlQueryVariables>;
export const CreateEmrConnectionDocument = gql`
    mutation createEMRConnection($input: PostEmrConnectionInput!) {
  postDirectEmrApiConnection(input: $input) {
    vitall_patient_id
    fhir_api_endpoint_id
    patient
    expiry
    created_at
    updated_at
  }
}
    `;
export type CreateEmrConnectionMutationFn = Apollo.MutationFunction<CreateEmrConnectionMutation, CreateEmrConnectionMutationVariables>;
export function useCreateEmrConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmrConnectionMutation, CreateEmrConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmrConnectionMutation, CreateEmrConnectionMutationVariables>(CreateEmrConnectionDocument, options);
      }
export type CreateEmrConnectionMutationHookResult = ReturnType<typeof useCreateEmrConnectionMutation>;
export type CreateEmrConnectionMutationResult = Apollo.MutationResult<CreateEmrConnectionMutation>;
export type CreateEmrConnectionMutationOptions = Apollo.BaseMutationOptions<CreateEmrConnectionMutation, CreateEmrConnectionMutationVariables>;
export const DeleteEmrConnectionDocument = gql`
    mutation deleteEMRConnection($input: EmrConnectionInput!) {
  deleteDirectEmrApiConnection(input: $input) {
    vitall_patient_id
    fhir_api_endpoint_id
    patient
    expiry
    created_at
    updated_at
  }
}
    `;
export type DeleteEmrConnectionMutationFn = Apollo.MutationFunction<DeleteEmrConnectionMutation, DeleteEmrConnectionMutationVariables>;
export function useDeleteEmrConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmrConnectionMutation, DeleteEmrConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmrConnectionMutation, DeleteEmrConnectionMutationVariables>(DeleteEmrConnectionDocument, options);
      }
export type DeleteEmrConnectionMutationHookResult = ReturnType<typeof useDeleteEmrConnectionMutation>;
export type DeleteEmrConnectionMutationResult = Apollo.MutationResult<DeleteEmrConnectionMutation>;
export type DeleteEmrConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteEmrConnectionMutation, DeleteEmrConnectionMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetDirectEmrIntegrations = withQueryResponseHandler(useGetDirectEmrIntegrationsQuery);
export const useGetEmrConnections = withQueryResponseHandler(useGetEmrConnectionsQuery);
export const useGetAuthorizationUrl = withQueryResponseHandler(useGetAuthorizationUrlQuery);
export const useCreateEmrConnection = withMutationResponseHandler(useCreateEmrConnectionMutation, "createEmrConnection");
export const useDeleteEmrConnection = withMutationResponseHandler(useDeleteEmrConnectionMutation, "deleteEmrConnection");